exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".selected-option {\n  padding: 12px 10px;\n  border-bottom: 1px solid #e1e1e1;\n  background: #fff;\n  font-size: 13px;\n  color: #777;\n}\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/Support/SelectedOption/SelectedOption.css"],"names":[],"mappings":"AAAA;EACE,mBAAkB;EAClB,iCAAgC;EAChC,iBAAgB;EAChB,gBAAe;EACf,YAAU;CACZ","file":"SelectedOption.css","sourcesContent":[".selected-option{\n  padding: 12px 10px;\n  border-bottom: 1px solid #e1e1e1;\n  background: #fff;\n  font-size: 13px;\n  color:#777;\n}"],"sourceRoot":""}]);

// exports
